import { createAction, props } from '@ngrx/store';

export const updatePassword = createAction('[Password] update password', props<{password: any}>());
export const updateConfirmPassword = createAction('[Password] update confirm password', props<{confirmPassword: any}>());
